/** String constants for Fund Commitments page. */
export const PAGE = {
  title: 'Fund Commitments',
  description:
    'Manage fund commitments. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Fund Commitment',
  edit: 'Update Fund Commitment',
  delete: 'Delete Fund Commitment',
  cancel: 'Cancel',
};

export const PARTNER_FILTER = {
  selectId: 'fund-commitment-partner',
};

export const PROJECT_FILTER = {
  selectId: 'fund-commitment-project',
};

export const MESSAGES = {
  createSuccess: 'Fund commitment created successfully.',
  createError: 'Unable to create fund commitment. Please try again.',
  updateSuccess: 'Fund commitment updated successfully.',
  updateError: 'Unable to update fund commitment. Please try again.',
  updateMissingId: 'Unable to update fund commitment: missing identifier.',
  deleteSuccess: 'Fund commitment deleted successfully.',
  deleteError: 'Unable to delete fund commitment. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update fund commitment?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete fund commitment?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this fund commitment'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};
